import _findIndex from 'lodash/findIndex';

const EventTypes = [
  {
    label: 'Welcome Event',
    title: 'Welcome Event',
    value: 'WELCOME_EVENT',
  },
  {
    label: 'Rehearsal Dinner',
    title: 'Rehearsal Dinner',
    value: 'REHEARSAL_DINNER',
  },
  {
    label: 'Wedding',
    title: 'Wedding',
    value: 'WEDDING',
  },
  {
    label: 'Ceremony',
    title: 'Ceremony',
    value: 'CEREMONY',
  },
  {
    label: 'Reception',
    title: 'Reception',
    value: 'RECEPTION',
  },
  {
    label: 'After Party',
    title: 'After Party',
    value: 'AFTER_PARTY',
  },
  {
    label: 'Brunch',
    title: 'Brunch',
    value: 'BRUNCH',
  },
  {
    label: 'Other',
    title: 'Other',
    value: 'OTHER',
  },
];

export const getEventType = eventType => {
  const idx = _findIndex(EventTypes, elem => elem.value === eventType);
  return idx >= 0 ? EventTypes[idx].title : '';
};

export default EventTypes;



// WEBPACK FOOTER //
// ./src/components/manage/events/util/EventTypes.js